var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Cupones","storeName":"Coupons","labelAddNew":"Agregar","next-link":"/admin/notifications_request_cms","breadcrumbs":[
    {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '#',
      },
      {
        text: 'Cupones',
        disabled: false,
        href: '#',
      }
  ],"sortable":"","canSearch":""},scopedSlots:_vm._u([{key:"user_coupons",fn:function({item}){return [_c('v-btn',{staticClass:"my-1 btn-black btn-round-md",attrs:{"elevation":"0","rounded":"","color":"primary"},on:{"click":function($event){return _vm.$router.push('/admin/coupons/' + item.id + '/user_coupons')}}},[_vm._v(" Cupones "),_c('br'),_vm._v(" de Usuario ")])]}},{key:"head_item",fn:function({}){return [_c('v-btn',{attrs:{"elevation":"0","text":""},on:{"click":function($event){return _vm.$router.push('/admin/coupons_bulk/add')}}},[_vm._v(" Crear Cupones para Usuarios ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }